
import { useState } from 'react';
//import Augusta from "../../Imagenes/Augusta.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faGift} from '@fortawesome/free-solid-svg-icons'
import { Fade } from "react-awesome-reveal";

function Regalos() {
  const [mostrarInfo, setMostrarInfo] = useState(false);

  const handleMostrarInfo = () => {
    setMostrarInfo(!mostrarInfo);
  };

  return (
    <div className= "w-full min-h-[60vh] bg-verde4 flex justify-center items-center">
    <div className="text-center ml-4 mr-4 max-w-4xl">
      <h2 className="font-Libre-Baskerville text-verde1 text-3xl md:text-5xl font-bold mt-8">Regalos</h2>
      <div  className='flex justify-center items-center mb-10 mt-8'>
      <Fade cascade={true} duration={3000}>
      <FontAwesomeIcon icon={faGift} size="5x"  className="text-verde1" />
      </Fade>
      </div>
      <div className="flex justify-center items-center mb-14 ">
       {/* <a href="https://www.mercadolibre.com.ar/" className="mr-2">
          <img src={Augusta} alt="Regalo 1" className="w-48 h-48 rounded-full overflow-hidden shadow-md hover:scale-105 transition-transform duration-300" />
        </a>*/}
        <button className="font-bold text-sm text-white bg-verde1 rounded-md px-4 py-2 transition-colors duration-300 ease-in-out hover:bg-verde1 focus:outline-none focus:ring-2 focus:ring-verde1 focus:ring-opacity-50" onClick={handleMostrarInfo}>
          <p className="mb-2">Lo más importante para nosotros en este día tan especial,</p>
          <p className="mb-2">es poder contar con tu presencia,</p>
          <p className="mb-2">pero si deseas hacerme otro regalo</p>
          <p className="mb-2">click aquí</p>
        </button>
        { mostrarInfo && (
          <div className="text-left mt-4 break-words">
            <h3 className="font-bold text-1xl mb-2">Datos para transferencia bancaria en pesos:</h3>
            <p>Banco: Banco Macro</p>
            <p>Número de cuenta: 456209458603496</p>
            <p>Alias: BET.PROKO</p>
            <p>CBU: 2850562640094586034968</p>
            <p>Nombre del titular de la cuenta: BETIANA ESTEFANIA PROKOPIEC</p>
            <h3 className="font-bold text-1xl mb-2">Datos para transferencia bancaria en dólares:</h3>
            <p>Banco: Banco Macro</p>
            <p>Número de cuenta: 256209549932355</p>
            <p>Alias: CHISTE.SOMBRA.FARO</p>
            <p>CBU: 2850562620095499323554</p>
            <p>Nombre del titular de la cuenta: BETIANA ESTEFANIA PROKOPIEC</p>
          </div>
          
        )}
      </div>
    </div></div>
  );
}

export default Regalos;